"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.delRole = delRole;
exports.getInfo = getInfo;
exports.getRoleList = getRoleList;
exports.menuCacheList = menuCacheList;
exports.updateRole = updateRole;
exports.updateRoleStatus = updateRoleStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增
 * @param
 */
function addRole(pram) {
  var data = {
    level: pram.level,
    roleName: pram.roleName,
    status: pram.status,
    rules: pram.rules
  };
  // data.rules = pram.rules.join(',')
  return (0, _request.default)({
    url: '/admin/platform/role/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 * @param
 */
function delRole(id) {
  return (0, _request.default)({
    url: "admin/platform/role/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 详情
 * @param
 */
function getInfo(pram) {
  return (0, _request.default)({
    url: "/admin/platform/role/info/".concat(pram),
    method: 'GET'
  });
}

/**
 * 分页列表
 * @param
 */
function getRoleList(pram) {
  var data = {
    createTime: pram.createTime,
    updateTime: pram.updateTime,
    level: pram.level,
    page: pram.page,
    limit: pram.limit,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/platform/role/list',
    method: 'get',
    params: data
  });
}

/**
 * 修改
 * @param
 */
function updateRole(pram) {
  var data = {
    id: pram.id,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/platform/role/update',
    method: 'post',
    params: {
      id: pram.id
    },
    data: data
  });
}

/**
 * 修改身份状态
 * @param
 */
function updateRoleStatus(data) {
  return (0, _request.default)({
    url: '/admin/platform/role/updateStatus',
    method: 'post',
    data: data
  });
}

/**
 * 缓存菜单
 * @param
 */
function menuCacheList(pram) {
  return (0, _request.default)({
    url: '/admin/platform/menu/cache/tree',
    method: 'get'
  });
}